import { ErrorMessage } from '../../core/model/error-message';


export interface IBoolResult {
    result:     boolean;
    message:    ErrorMessage | null;
}

export class BoolResult {

    // ------------------------------------------------------------------------------------------------
    // -- Message Creators ----------------------------------------------------------------------------
    // ------------------------------------------------------------------------------------------------
    public static createBoolResult_false(
        code: string
    ): IBoolResult {
        return { result: false, message: new ErrorMessage(code) };
    }

    public static createBoolResult_falseNoMsg(
    ): IBoolResult {
        return { result: false, message: null };
    }

    public static createBoolResult2_false(
        code: string,
        message: string
    ): IBoolResult {
        return { result: false, message: new ErrorMessage(code, message) };
    }

    public static createBoolResult3_false(
        code: string,
        message: string,
        module: string
    ): IBoolResult {
        return { result: false, message: new ErrorMessage(code, message, module) };
    }

    public static createBoolResult_falseTakeMessage(
        messObj: ErrorMessage
    ): IBoolResult {
        if (!messObj) {console.error('[BoolResult] Passed param not valid'); }
        return { result: false, message: messObj };
    }

    public static createBoolResult_true(
    ): IBoolResult {
        return { result: true, message: null };
    }

    public static createBoolResult_takeMessage(
        result: boolean,
        message: ErrorMessage
    ): IBoolResult {
        if (!message) {console.error('[BoolResult] Passed param not valid'); }
        return { result: result, message: message };
    }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/interfaces/bool-result.ts